<script setup lang="ts">
useHead({ title: 'Know more about Kathiravan K | Sr.UI Developer' })
</script>

<template>
  <div class="about-page">
    <a class="skip-link" href="#aboutMaincontent">Skip to main</a>
    <div id="aboutMaincontent" class="container">
      <figure class="avatar is-128x128">
        <img
          src="/profile-photo.jpg"
          alt="User Profile photo"
          height="128"
          width="128"
        >
      </figure>
      <p>
        My name is Kathiravan Kumarasamy and I am
        <strong>Sr.UI Developer</strong> and <strong>Freelance Developer</strong>.
      </p>
      <br>
      <p>
        I have a Bachelor's degree in Electronics and Communications Engineering
        and several years of experience working on a wide range of technologies
        and projects for web applications in
        <strong>HTML/HTML5</strong>, <strong>CSS/CSS3</strong>,
        <strong>Javascript</strong>, <strong>jQuery</strong>,
        <strong>Gulp.js</strong>, <strong>Node.js</strong>,
        <strong>Vue.js</strong>, <strong>Vue Router</strong>, <strong>Vuex/Pinia</strong>, <strong>@Tanstack/Vue-Query</strong>,
        <strong>Nuxt.js</strong>, <strong>Vuetify.js</strong>,
        <strong>Bulma</strong>, <strong>Tailwind</strong>,
        <strong>Bootstrap</strong>, <strong>Bootstrap-Vue</strong>,
        <strong>Firebase</strong>, <strong>Firestore</strong>,
        <strong>MongodB</strong> and <strong>Git/Github</strong>.
      </p>
      <br>
      <p>Throughout my career, I have acquired advanced technical knowledge in Web Technologies.</p>
    </div>
  </div>
</template>

<style scoped lang="scss">
.about-page {
  padding: 1rem;
  font-size: 18px;
  @media screen and (min-width: 576px) {
    font-size: 26px;
  }
}
.avatar {
  margin-right: 20px;
  float: left;
}
.avatar img {
  height: 128px;
  width: 128px;
  padding: 5px;
  background: #fff;
  border-radius: 50%;
  box-shadow:
    0 2px 3px rgba(10, 10, 10, 0.1),
    0 0 0 1px rgba(10, 10, 10, 0.1);
}
</style>
